// extracted by mini-css-extract-plugin
export var dropdownButton = "_33-0";
export var fullWidthDropdownButton = "_33-1";
export var icon = "_33-3";
export var iconPlaceholder = "_33-2";
export var menuItemRow = "_33-9";
export var separator = "_33-e";
export var shortcutContainer = "_33-7";
export var shortcutContainerFilled = "_33-8";
export var shortcutIconLg = "_33-6";
export var shortcutIconMd = "_33-5";
export var shortcutIconSm = "_33-4";
export var submenuChevron = "_33-d";
export var submenuDropdown = "_33-a";
export var submenuTriggerRow = "_33-b";
export var submenuTriggerRowOpen = "_33-c";